import * as types from "../constants";

export function HandleUserConnectivity(isConnected: boolean): types.HandleUserConnectivity {
    return {
        type: types.HANDLE_USER_CONNECTIVITY,
        payload: isConnected
    };
}